import React, { useState } from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import {
  Dialog,
  DialogActions,
  DialogTitle
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  
} from "../../store/actions";
// import PaymentModal from '../../Comments/paymentforModal'
// import Loader from "../../loader";
import { useRef } from "react";
// import RaiseComplaintModal from "../../Comments/raiseTicketModal";
// import { generateEmailFilterUrl } from "../../../../helpers/generateUrl";
// import ReportModal from "../../Comments/reportStatusModal";
// import MainMemberSyncModal from './SyncMainMemberModal'
import "./index.sass";
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 0,
    },
    toolbar: {
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(0, 1),
      ...theme.mixins.toolbar,
    },
    content: {
      width: "80%",
      flexGrow: 21,
    },
    tableHead: {
      fontWeight: "bold",
      textTransform: "capitalize",
      textAlign: "center",
    },
    contentHeader: {
      width: "100%",
    },
    rightContentHeader: {
      width: "100%",
    },
    contentTable: {
      width: "100%",
      clear: "both",
    },
    formControl: {
      margin: theme.spacing(3),
    },

    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    paper: {
      marginTop: "2rem",
      padding: "0.5rem 2rem",
      width: "100%",
    },
    heading: {
      fontSize: "1.3rem",
      marginTop: "1rem",
    },
    appBar: {
      position: "relative",
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    slotContainer: {
      width: "100%",
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      justifyContent: "center",
    },
    slot: {
      width: "150px",
      height: "100px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      margin: "0.5rem",
    },
    selectedSlot: {
      width: "150px",
      height: "100px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      background: "linear-gradient(60deg, cyan, #00dfff, cyan)",
      cursor: "pointer",
      margin: "0.5rem",
    },
  })
);

interface Props {
  
}

const ViewBooking: React.FC<Props> = ({
 
}) => {
  const classes = useStyles();
  const [raiseComplaint, setRaiseComplaint] = useState(false);
  const [cancelAlert, setCancelAlert] = useState(false);
  const [assignBooking, setAssignBooking] = useState(false);
  const [doctor, setDoctor] = useState(0);
  const timer = useRef<any>(0);

  
  

  
  return (
    <>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <div className={classes.contentHeader}>

          <div className={classes.rightContentHeader}>
            
                <Button
                  variant="contained"
                  style={{ background: "#d50000", marginLeft: "1rem", marginBottom: "1rem" }}
                  // onClick={() => handleCancelBooking()}
                >
                  Cancel
                </Button>
            
            <Link
              to={`/dashboard/gch/booking-additionalFamily`}
              style={{ textDecoration: "none" }}
            >
            </Link>
            <Link
              to={`/dashboard/gch/booking-edit`}
              style={{ textDecoration: "none" }}
            >
              <Button
                variant="contained"
                style={{ background: "#1976d2", marginLeft: "1rem", marginBottom: "1rem" }}
              >
                Edit
              </Button>
            </Link>
            <Link
              to={`/dashboard/gnrelab/billing`}
              style={{ textDecoration: "none" }}
            >
              <Button
                variant="contained"
                style={{ background: "#1976d2", marginLeft: "1rem", marginBottom: "1rem" }}
              >
                Close Project
              </Button>
            </Link>
            {/* <Link
              to={`/dashboard/gnrelab/billing`}
              style={{ textDecoration: "none" }}
            >
              <Button
                variant="contained"
                style={{ background: "#1976d2", marginLeft: "1rem", marginBottom: "1rem" }}
              >
                Billing & Project Closer
              </Button>
            </Link> */}
          </div>
          </div>

        <div className={classes.contentTable}>
          <Dialog
            open={cancelAlert}
            onClose={() => setCancelAlert(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">Are you sure!!</DialogTitle>
            
            <DialogActions>
              <Button onClick={() => setCancelAlert(false)} color="primary">
                Discard
              </Button>
              
            </DialogActions>
          </Dialog>
        </div>
      </main>
    </>
  );
};

const mapStateToProps = (state: any) => ({
  
});

export default connect(mapStateToProps, {

})(ViewBooking);
